import { render, staticRenderFns } from "./DialCodeSelect.vue?vue&type=template&id=5e22c202"
import script from "./DialCodeSelect.vue?vue&type=script&lang=js"
export * from "./DialCodeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports